module.exports = __webpack_public_path__ + "img/horizontal_4_7_r_8023.4c3f87bb.png";